import { DIALOG_DATA } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  signal,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SimpleModalInputBindings } from '@app/shared/components/modal/simple-modal/simple-modal.component';
import { DialogService } from '@degreed/apollo-angular';

@Component({
    selector: 'dgx-cancel-tag-rating-request-modal-v3',
    imports: [],
    templateUrl: './cancel-tag-rating-request-modal-v3.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelTagRatingRequestModalV3Component {
  public headerText = signal<string>(this.data.headerText);
  public bodyText = signal<string | SafeHtml>(this.data.bodyText);
  public cancelButtonText = signal<string>(this.data.cancelButtonText);
  public submitText = signal<string>(this.data.submitButtonText);

  constructor(
    @Inject(DIALOG_DATA) public data: SimpleModalInputBindings,
    private dialogService: DialogService
  ) {}

  public cancel(): void {
    this.dialogService.close(CancelTagRatingRequestModalV3Component);
  }

  public submit(): void {
    this.dialogService.close(CancelTagRatingRequestModalV3Component, 'submit');
  }
}
